import "./widgets-core16.css";
import { defineComponent as s, useCssVars as a, unref as r, openBlock as n, createElementBlock as p, normalizeClass as l, renderSlot as m } from "vue";
import { u as d } from "./chunks/useTheme.L4REnSCw.js";
import { _ as i } from "./chunks/_plugin-vue_export-helper.CHgC5LLL.js";
const u = ["disabled"], f = /* @__PURE__ */ s({
  __name: "Button",
  props: {
    appearance: { default: "outline" },
    disabled: { type: Boolean },
    colorScheme: {}
  },
  setup(c) {
    a((e) => ({
      "13ef9c2c": e.$props.colorScheme.main,
      "06adacc1": e.$props.colorScheme.main || r(o).actionColor.base,
      "5d8c4885": e.$props.colorScheme.text || r(o).actionColor.contrasted,
      e4c9c3c2: e.$props.colorScheme.over || r(o).actionColor.over,
      "13e91d44": e.$props.colorScheme.text
    }));
    const t = c, o = d();
    return (e, h) => (n(), p("button", {
      class: l([
        "btn",
        t.appearance
      ]),
      disabled: t.disabled
    }, [
      m(e.$slots, "default", {}, void 0, !0)
    ], 10, u));
  }
}), $ = /* @__PURE__ */ i(f, [["__scopeId", "data-v-51c48b8b"]]);
export {
  $ as default
};
//# sourceMappingURL=widgets-core.es18.js.map
